import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const welcomeOverviewMessagesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWelcomeOverviewMessages: builder.query({
      query: ({
        patientProfileId,
        patientCaseId,
        preferredLanguage
      }: {
        patientProfileId: number;
        patientCaseId: number;
        preferredLanguage: string;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Patient/${patientProfileId}/${patientCaseId}/welcome-overview`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetWelcomeOverviewMessagesQuery } =
  welcomeOverviewMessagesApi;
export default welcomeOverviewMessagesApi;
